import React, { Component } from 'react';

class Thankspage extends Component {
    render() {
        return (
            <div className="wrap">
                <section className="py-24 px-4 sm:px-6">
                    <div className="max-w-lg mx-auto text-center">
                        <i className="fa fa-check-circle text-accent" style={{ fontSize: 80 }}></i>
                        <h1 className="mt-6 text-4xl sm:text-5xl font-bold text-ink-primary">
                            THANK <span className="text-accent">YOU!</span>
                        </h1>
                        <div className="mx-auto mt-3 h-1 w-16 bg-accent rounded-full"></div>
                        <p className="mt-6 text-ink-secondary leading-relaxed">
                            I'll get back to you as soon as possible. For urgent matters please reach out via LinkedIn (link in the footer).
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}
export default Thankspage;
